<!-- Fly ins -->
<wb-header-fly-in-container open="{{ isNavigationLvlOneOpened || isNavigationLvlTwoOpened }}">
  <!-- MOBILE - LVL 1 -->
  <wb-header-mobile-fly-in
    class="mobile-nav-1"
    level="1"
    headline="Mercedes-Benz Media"
    open="{{ isNavigationLvlOneOpened }}"
  >
    <a slot="top-bar-start" class="star-icon" routerLink="/" [attr.aria-label]="'GO_TO_HOMEPAGE' | translate">
      <img class="logo" src="assets/img/mb_logo_star.svg" alt="Mercedes-Benz Media Logo" width="38" height="38" />
    </a>
    <wb-header-button slot="top-bar-end" (click)="closeNavigationMenu()" label="{{ 'CLOSE' | translate }}">
      <wb-icon name="bds/close/24"></wb-icon>
    </wb-header-button>

    @if (lvlOneNavigationMenus$ | async; as navigationMenus) {
      @for (item of navigationMenus; track item.id) {
        <wb-header-fly-in-item (click)="openNavigationMenu(2, item)"
          >{{ 'MENU.' + item.id + '.NAME' | translate }}
          @if (item.children?.length) {
            <wb-icon slot="icon" name="bds/chevron-right/24" flip-rtl></wb-icon>
          }
        </wb-header-fly-in-item>
      }
    }

    <wb-header-tool-list slot="bottom-section">
      <wb-header-tool-list-item mbRouterLink="/search" (mbNavigate)="closeNavigationMenu()">
        <wb-icon slot="icon" name="bds/layers/24" flip-rtl></wb-icon>
        {{ 'ALL_CONTENT' | translate }}
      </wb-header-tool-list-item>
    </wb-header-tool-list>

    <div class="bottom-link-container" slot="bottom-section">
      <wb-link mbRouterLink="/presscontacts" variant="small" (mbNavigate)="headerService.closeMenu()">{{
        'PRESS_CONTACTS' | translate
      }}</wb-link>
      <wb-link
        mbRouterLink="/legal/provider"
        [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
        variant="small"
        (mbNavigate)="headerService.closeMenu()"
        >{{ 'PROVIDER_PRIVACY' | translate }}</wb-link
      >
    </div>

    <wb-header-language-menu aria-label="{{ 'LANGUAGE_MENU' | translate }}" slot="footer">
      @for (lang of languages; track lang.isoLang) {
        <wb-header-language-menu-item
          (click)="changeLanguage(lang.isoLang)"
          [active]="currentLanguage === lang.isoLang"
        >
          {{ lang.label }}
        </wb-header-language-menu-item>
      }
    </wb-header-language-menu>
  </wb-header-mobile-fly-in>

  <!-- MOBILE - LVL 2 -->
  @if (lvlTwoNavigationMenu) {
    <wb-header-mobile-fly-in
      class="mobile-nav-2"
      level="2"
      headline="{{ 'MENU.' + lvlTwoNavigationMenu.id + '.NAME' | translate }}"
      back-button-label="{{ 'BACK' | translate }}"
      close-button-label="{{ 'CLOSE' | translate }}"
      open="{{ isNavigationLvlTwoOpened }}"
      (wbback)="onBack(1)"
      show-back-button
    >
      <wb-header-button slot="top-bar-end" (click)="closeNavigationMenu()" label="{{ 'CLOSE' | translate }}">
        <wb-icon name="bds/close/24"></wb-icon>
      </wb-header-button>
      @if (lvlTwoNavigationMenu.children?.length) {
        <wb-header-fly-in-item (click)="navigateToPage(lvlTwoNavigationMenu)"
          >{{ 'ALL_PRESS_CONTENT' | translate }}
        </wb-header-fly-in-item>
      }
      @for (item of lvlTwoNavigationMenu.children; track item.id) {
        <wb-header-fly-in-item (click)="openNavigationMenu(3, item)">
          {{ 'MENU.' + item.id + '.NAME' | translate }}
          @if (item.children?.length) {
            <wb-icon slot="icon" name="bds/chevron-right/24" flip-rtl></wb-icon>
          }
        </wb-header-fly-in-item>
      }
    </wb-header-mobile-fly-in>
  }

  <!-- MOBILE - LVL 3 -->
  @if (lvlThreeNavigationMenu) {
    <wb-header-mobile-fly-in
      class="mobile-nav-3"
      level="2"
      headline="{{ 'MENU.' + lvlThreeNavigationMenu.id + '.NAME' | translate }}"
      back-button-label="{{ 'BACK' | translate }}"
      close-button-label="{{ 'CLOSE' | translate }}"
      open="{{ isNavigationLvlThreeOpened }}"
      (wbback)="onBack(2)"
      show-back-button
    >
      <wb-header-button slot="top-bar-end" (click)="closeNavigationMenu()" label="{{ 'CLOSE' | translate }}">
        <wb-icon name="bds/close/24"></wb-icon>
      </wb-header-button>
      @if (lvlThreeNavigationMenu.children?.length) {
        <wb-header-fly-in-item (click)="navigateToPage(lvlThreeNavigationMenu)"
          >{{ 'ALL_PRESS_CONTENT' | translate }}
        </wb-header-fly-in-item>
      }
      @for (item of lvlThreeNavigationMenu.children; track item.id) {
        <wb-header-fly-in-item (click)="openNavigationMenu(4, item)">
          {{ 'MENU.' + item.id + '.NAME' | translate }}
          @if (item.children?.length) {
            <wb-icon slot="icon" name="bds/chevron-right/24" flip-rtl></wb-icon>
          }
        </wb-header-fly-in-item>
      }
    </wb-header-mobile-fly-in>
  }

  <!-- MOBILE - LVL 4 -->
  @if (lvlFourNavigationMenu) {
    <wb-header-mobile-fly-in
      class="mobile-nav-4"
      level="2"
      headline="{{ 'MENU.' + lvlFourNavigationMenu.id + '.NAME' | translate }}"
      back-button-label="{{ 'BACK' | translate }}"
      close-button-label="{{ 'CLOSE' | translate }}"
      open="{{ isNavigationLvlFourOpened }}"
      (wbback)="onBack(3)"
      show-back-button
    >
      <wb-header-button slot="top-bar-end" (click)="closeNavigationMenu()" label="{{ 'CLOSE' | translate }}">
        <wb-icon name="bds/close/24"></wb-icon>
      </wb-header-button>
      @if (lvlFourNavigationMenu.children?.length) {
        <wb-header-fly-in-item (click)="navigateToPage(lvlFourNavigationMenu)"
          >{{ 'ALL_PRESS_CONTENT' | translate }}
        </wb-header-fly-in-item>
      }
      @for (item of lvlFourNavigationMenu.children; track item.id) {
        <wb-header-fly-in-item (click)="navigateToPage(item)">
          {{ 'MENU.' + item.id + '.NAME' | translate }}
        </wb-header-fly-in-item>
      }
    </wb-header-mobile-fly-in>
  }

  <!-- DESKTOP and TABLET - LVL 1 -->
  <wb-header-desktop-fly-in
    class="tablet-main-nav"
    level="1"
    headline="Mercedes-Benz Media"
    back-button-label="{{ 'BACK' | translate }}"
    close-button-label="{{ 'CLOSE' | translate }}"
    open="{{ isNavigationLvlOneOpened && (isTabletView || isDesktopView) }}"
    (wbclose)="closeNavigationMenu()"
  >
    @if (lvlOneNavigationMenus$ | async; as navigationMenus) {
      @for (item of navigationMenus; track item.id) {
        <wb-header-fly-in-item (click)="openNavigationMenu(2, item)" [active]="isActive(item)">
          {{ 'MENU.' + item.id + '.NAME' | translate }}
          @if (item.children?.length) {
            <wb-icon slot="icon" name="bds/chevron-right/24" flip-rtl></wb-icon>
          }
        </wb-header-fly-in-item>
      }
    }

    @if (isTabletView || isDesktopView) {
      <wb-header-tool-list slot="bottom-section">
        <wb-header-tool-list-item mbRouterLink="/search" (mbNavigate)="closeNavigationMenu()">
          <wb-icon slot="icon" name="bds/layers/24" flip-rtl></wb-icon>
          {{ 'ALL_CONTENT' | translate }}
        </wb-header-tool-list-item>
      </wb-header-tool-list>
      <div class="bottom-link-container" slot="bottom-section">
        <wb-link mbRouterLink="/presscontacts" variant="small" (mbNavigate)="headerService.closeMenu()">{{
          'PRESS_CONTACTS' | translate
        }}</wb-link>
        <wb-link
          mbRouterLink="/legal/provider"
          [mbRouterLinkExtras]="{ state: { scrollRestoration: 'top' } }"
          variant="small"
          (mbNavigate)="headerService.closeMenu()"
          >{{ 'PROVIDER_PRIVACY' | translate }}</wb-link
        >
      </div>
    }
  </wb-header-desktop-fly-in>

  <!-- DESKTOP AND TABLET - LVL 2-->
  @if (lvlTwoNavigationMenu) {
    <wb-header-desktop-fly-in
      level="{{ isTabletView ? 2 : 1 }}"
      headline="{{ 'MENU.' + lvlTwoNavigationMenu.id + '.NAME' | translate }}"
      back-button-label="{{ 'BACK' | translate }}"
      close-button-label="{{ 'CLOSE' | translate }}"
      open="{{ isNavigationLvlTwoOpened }}"
      (wbback)="onBack(1)"
      (wbclose)="closeNavigationMenu()"
      show-back-button
    >
      @if (lvlTwoNavigationMenu.children?.length) {
        <wb-header-fly-in-item (click)="navigateToPage(lvlTwoNavigationMenu)">
          {{ 'ALL_PRESS_CONTENT' | translate }}
        </wb-header-fly-in-item>
      }
      @for (item of lvlTwoNavigationMenu.children; track item.id) {
        <wb-header-fly-in-item (click)="openNavigationMenu(3, item)" [active]="isActive(item)">
          {{ 'MENU.' + item.id + '.NAME' | translate }}
          @if (item.children?.length) {
            <wb-icon slot="icon" name="bds/chevron-right/24" flip-rtl></wb-icon>
          }
        </wb-header-fly-in-item>
      }
      @if (!isTabletView) {
        <wb-header-tool-list slot="bottom-section">
          <wb-header-tool-list-item mbRouterLink="/search" (mbNavigate)="closeNavigationMenu()">
            <wb-icon slot="icon" name="bds/layers/24" flip-rtl></wb-icon>
            {{ 'ALL_CONTENT' | translate }}
          </wb-header-tool-list-item>
        </wb-header-tool-list>
      }
    </wb-header-desktop-fly-in>
  }

  <!-- DESKTOP AND TABLET - LVL 3-->
  @if (lvlThreeNavigationMenu) {
    <wb-header-desktop-fly-in
      level="2"
      headline="{{ 'MENU.' + lvlThreeNavigationMenu.id + '.NAME' | translate }}"
      back-button-label="{{ 'BACK' | translate }}"
      close-button-label="{{ 'CLOSE' | translate }}"
      open="{{ isNavigationLvlThreeOpened }}"
      (wbback)="onBack(2)"
      (wbclose)="closeNavigationMenu()"
    >
      @if (lvlThreeNavigationMenu.children?.length) {
        <wb-header-fly-in-item (click)="navigateToPage(lvlThreeNavigationMenu)"
          >{{ 'ALL_PRESS_CONTENT' | translate }}
        </wb-header-fly-in-item>
      }
      @for (item of lvlThreeNavigationMenu.children; track item.id) {
        <wb-header-fly-in-item (click)="openNavigationMenu(4, item)" [active]="isActive(item)">
          {{ 'MENU.' + item.id + '.NAME' | translate }}
          @if (item.children?.length) {
            <wb-icon slot="icon" name="bds/chevron-right/24" flip-rtl></wb-icon>
          }
        </wb-header-fly-in-item>
      }
    </wb-header-desktop-fly-in>
  }

  <!-- DESKTOP AND TABLET - LVL 4 -->
  @if (lvlFourNavigationMenu) {
    <wb-header-desktop-fly-in
      level="3"
      headline="{{ 'MENU.' + lvlFourNavigationMenu.id + '.NAME' | translate }}"
      back-button-label="{{ 'BACK' | translate }}"
      close-button-label="{{ 'CLOSE' | translate }}"
      open="{{ isNavigationLvlFourOpened }}"
      (wbback)="onBack(3)"
      (wbclose)="closeNavigationMenu()"
    >
      @if (lvlFourNavigationMenu.children?.length) {
        <wb-header-fly-in-item (click)="navigateToPage(lvlFourNavigationMenu)"
          >{{ 'ALL_PRESS_CONTENT' | translate }}
        </wb-header-fly-in-item>
      }
      @for (item of lvlFourNavigationMenu.children; track item.id) {
        <wb-header-fly-in-item (click)="navigateToPage(item)" [active]="isActive(item)">
          {{ 'MENU.' + item.id + '.NAME' | translate }}
        </wb-header-fly-in-item>
      }
    </wb-header-desktop-fly-in>
  }
</wb-header-fly-in-container>
